import React, {Component} from "react"
import styled from "styled-components"
import {InjectedIntl} from "react-intl"

import {TextArea as TextAreaBase} from "@irati/ui/src/FormItem"
import {EMOJI} from "@irati/ui/src/Reactions/constants"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"
import {injectIntl, InjectIntl} from "@irati/utils/lang"

const MAX_CHAR_LENGTH = 280

export const schema = (intl: InjectedIntl) =>
  Validation.string(intl.formatMessage({id: "platform.defaultValidation.required"}))
    .test(
      "notJustSpaces",
      intl.formatMessage({id: "platform.defaultValidation.notJustSpaces"}),
      (value: string) => value && value.trim().length !== 0
    )
    .max(MAX_CHAR_LENGTH, intl.formatMessage({id: "platform.defaultValidation.maxLength"}, {count: intl.formatNumber(MAX_CHAR_LENGTH)}))

const TextArea = styled(TextAreaBase)`
  textarea {
    resize: vertical;
  }
`

const PROPERTY = "message"

interface Props extends InjectIntl {
  id?: string,
  label?: string,
  message: string,
  onChange(message: string): void,
  placeholder?: string,
  validation?: () => void
}

class Message extends Component<Props> {
  static defaultProps = {
    id: "rewardMessage",
    label: "reward.fields.message.label",
    placeholder: "reward.fields.message.placeholder",
    validation: null
  }

  render() {
    const {onChange, message, intl, ...props} = this.props

    return (
      <TextArea
        {...props}
        id={id(PROPERTY, this.props)}
        name={id(PROPERTY, this.props)}
        onChange={onChange}
        rows={4}
        textReplaceTypes={[EMOJI]}
        validation={schema(intl)}
        value={message} />
    )
  }
}

export default injectIntl(Message)
